import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionPDFTemplateGenerationMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemPdfTemplate({ id, params }) {
  return request(`/actionPDFTemplateGenerationMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewPdfTemplate(params) {
  return request.post(`/actionPDFTemplateGenerationMapping`, {
    data: params,
  });
}

export async function queryAddEditPdfTemplate(params) {
  return request.put('/actionPDFTemplateGenerationMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionPDFTemplateGenerationMapping/${id}`, {});
}
